import { useReducer } from 'react';

export type ChatState = {
  shouldRefreshChatSession: boolean;
  loadingChatSession: boolean;
  isResetting: boolean;
};

export const actionType = {
  START_FETCHING_CHAT_SESSION: 'START_FETCHING_CHAT_SESSION',
  CHAT_SESSION_FETCHED: 'CHAT_SESSION_FETCHED',
  RESET_CHAT: 'RESET_CHAT',
} as const;

export type ActionType =
  | 'START_FETCHING_CHAT_SESSION'
  | 'CHAT_SESSION_FETCHED'
  | 'RESET_CHAT';

type ChatAction = {
  type: ActionType;
};

const chatReducer = (state: ChatState, action: ChatAction): ChatState => {
  switch (action.type) {
    case actionType.START_FETCHING_CHAT_SESSION:
      return {
        ...state,
        shouldRefreshChatSession: true,
        loadingChatSession: true,
      };
    case actionType.CHAT_SESSION_FETCHED:
      return {
        ...state,
        loadingChatSession: false,
        isResetting: false,
      };
    case actionType.RESET_CHAT:
      return {
        shouldRefreshChatSession: true,
        loadingChatSession: true,
        isResetting: true,
      };
    default:
      return state;
  }
};

export const useChatProgress = () => {
  const [state, dispatch] = useReducer(chatReducer, {
    shouldRefreshChatSession: true,
    loadingChatSession: false,
    isResetting: false,
  });

  return { state, dispatch };
};
